import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs';
import { ALL_MENU_PERMISSION_KEYS, MENU_PERMISSIONS, MenuPermissionKey } from './menu-permissions';

const API = '/api';
const LEGACY_ALL_MENU_PERMISSION_KEYS = ['dashboard', 'clientes', 'notas', 'produtos', 'contagens_nova', 'contagens', 'pagamentos', 'ocorrencias', 'usuarios'];

interface LoginUsuario {
  cod_usuario: number;
  id_usuario: number;
  nome: string;
  email: string;
  login?: string;
  cpf_cadastrado?: boolean;
  tipo_usuario?: 'ADMINISTRADOR' | 'EXPEDICAO';
  permissoes_menu?: string[];
}

interface LoginResponse {
  token: string;
  usuario: LoginUsuario;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);

  get token() {
    return localStorage.getItem('token');
  }

  get usuario(): LoginUsuario | null {
    const raw = localStorage.getItem('usuario');
    return raw ? normalizeUsuarioPermissions(JSON.parse(raw)) : null;
  }

  get isLoggedIn() {
    return !!this.token;
  }

  canAccess(permissao: MenuPermissionKey) {
    if (this.usuario?.tipo_usuario !== 'EXPEDICAO') return true;
    return ['dashboard', 'contagens_nova', 'contagens'].includes(permissao);
  }

  firstAllowedPath() {
    const item = MENU_PERMISSIONS.find((permissao) => this.canAccess(permissao.key));
    return item?.path || '/login';
  }

  login(identificador: string, senha: string) {
    const value = identificador.trim();
    const cpf = value.replace(/\D/g, '');
    const credentials = cpf.length === 11 ? { cpf: value, senha } : { email: value.toLowerCase(), senha };

    return this.http.post<LoginResponse>(`${API}/auth/login`, credentials).pipe(
      tap((response) => {
        localStorage.setItem('token', response.token);
        localStorage.setItem('usuario', JSON.stringify(normalizeUsuarioPermissions(response.usuario)));
      })
    );
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
  }

  atualizarUsuario(usuario: LoginUsuario) {
    localStorage.setItem('usuario', JSON.stringify(normalizeUsuarioPermissions({
      ...this.usuario,
      ...usuario
    })));
  }
}

function normalizeUsuarioPermissions(usuario: LoginUsuario): LoginUsuario {
  const permissoes = usuario.permissoes_menu || ALL_MENU_PERMISSION_KEYS;
  const isLegacyFullAccess = LEGACY_ALL_MENU_PERMISSION_KEYS.every((permissao) => permissoes.includes(permissao))
    && (!permissoes.includes('conferencias_entrada') || !permissoes.includes('pagamentos') || !permissoes.includes('ocorrencias')
      || !permissoes.includes('caixa') || !permissoes.includes('contas_pagar') || !permissoes.includes('contas_receber') || !permissoes.includes('fornecedores'));

  return {
    ...usuario,
    permissoes_menu: isLegacyFullAccess ? ALL_MENU_PERMISSION_KEYS : permissoes
  };
}
